export { default } from './CautionDiamond'
